import { apiClient } from "../../../lib";

export interface DashboardStats {
  mundosActivos: number;
  etapasCreadas: number;
  preguntasHistoria: number;
  usuariosActivos: number;
}

export interface MundoStats {
  idMundoHistoria: number;
  nombre: string;
  totalEtapas: number;
  totalPreguntas: number;
  porcentaje: number;
}

export interface ActividadReciente {
  id: number;
  tipo: string;
  descripcion: string;
  fecha: string;
  mundo?: string;
  etapa?: string;
}

export interface DashboardData {
  stats: DashboardStats;
  mundosStats: MundoStats[];
}

export class DashboardService {
  // Obtener todas las estadísticas del dashboard en una sola consulta
  static async getDashboardData(): Promise<DashboardData> {
    try {
      const response = await apiClient.get("/dashboard/stats");
      return response.data.data;
    } catch (error) {
      console.error("Error obteniendo datos del dashboard:", error);
      return {
        stats: {
          mundosActivos: 0,
          etapasCreadas: 0,
          preguntasHistoria: 0,
          usuariosActivos: 0,
        },
        mundosStats: [],
      };
    }
  }

  // Obtener actividad reciente (placeholder)
  static async getActividadReciente(): Promise<ActividadReciente[]> {
    // TODO: Implementar endpoint de actividad reciente
    return [
      {
        id: 1,
        tipo: "pregunta",
        descripcion: "Nueva pregunta agregada al Mundo 3",
        fecha: "2024-01-15T10:30:00Z",
        mundo: "Historia Contemporánea",
        etapa: "Revolución Industrial",
      },
      {
        id: 2,
        tipo: "etapa",
        descripcion: "Actualización de etapa completada",
        fecha: "2024-01-15T08:15:00Z",
        mundo: "Mundo 1",
        etapa: "Etapa 2",
      },
      {
        id: 3,
        tipo: "mundo",
        descripcion: "Nuevo mundo creado",
        fecha: "2024-01-14T16:45:00Z",
        mundo: "Historia Contemporánea",
      },
      {
        id: 4,
        tipo: "sistema",
        descripcion: "Sistema actualizado",
        fecha: "2024-01-12T09:20:00Z",
      },
    ];
  }
}

export const dashboardService = new DashboardService();
